import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { HierarchyQueryParams } from "./HierarchyQueryParams";
import { HierarchyReadDto } from "./HierarchyReadDto";
import { HierarchyReadDtoDataReturn } from "./loadHierarchy";
import { HierarchyUpdateDto } from "./saveHierarchyData";

export interface SaveTocAsMajorVersionParams extends HierarchyQueryParams {
  parentTag: string;
  saveTocDescription: string;
  hierarchy?: HierarchyUpdateDto;
  hierarchyId: string;
}

/**
 * Save the table of contents as a new major version.
 *
 * @param backEndUrl - Base backend URL
 * @param update - Parameters for saving the TOC as a major version
 * @param controller - Optional AbortController
 * @returns The updated hierarchy wrapped in HierarchyReadDtoDataReturn
 */
export const saveTocAsMajorVersion = async (
  backEndUrl: string,
  update: SaveTocAsMajorVersionParams,
  controller?: AbortController,
): Promise<HierarchyReadDtoDataReturn> => {
  // Send data
  try {
    const url = `${backEndUrl}Reports/${update.hierarchyId}/SaveTocAsMajorVersion?parentTag=${update.parentTag}`;
    const data = { description: update.saveTocDescription, hierarchy: update.hierarchy };
    const response: { data: HierarchyReadDto } = await axios.put(
      url,
      data,
      controller ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Save failed", error);
  }
};
